import { create } from 'zustand';

interface SettingsState {
  activeTab: number;
  setActiveTab: (tab: number) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  activeTab: 1,
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
